import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { CURRENT_TEMPLATE } from 'app/core/services/google-tag-manager/use-current-template';
import { ANCHOR_ENABLED_TEMPLATES, isAnchorFragment } from 'app/core/utils/anchor-templates';
import { scrollToElementById } from 'app/core/utils/scroll-to-element.util';

const RETRY_DELAYS_MS = [0, 100, 300];

@Injectable({
  providedIn: 'root'
})
export class AnchorScrollService {
  readonly #router = inject(Router);
  readonly #currentTemplate = inject(CURRENT_TEMPLATE);

  init(): void {
    this.#router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((nav) => {
        const fragment = this.#extractFragment(nav.urlAfterRedirects);
        this.#scrollToFragment(fragment);
      });
  }

  #extractFragment(url: string): string | null {
    const hashIndex = url.indexOf('#');
    return hashIndex === -1 ? null : url.slice(hashIndex + 1);
  }

  #scrollToFragment(fragment: string | null): void {
    const template = this.#currentTemplate();
    if (!template || !ANCHOR_ENABLED_TEMPLATES.has(template)) {
      return;
    }
    if (!isAnchorFragment(fragment)) {
      return;
    }

    RETRY_DELAYS_MS.forEach((delay) => {
      setTimeout(() => scrollToElementById(fragment, { behavior: 'auto' }), delay);
    });
  }
}
